<template>
  <div class="container">
    <div v-if="error.statusCode === 404">
      <Page404 />
    </div>
    <!-- <h1>An error occurred</h1> -->
  </div>
</template>

<script>
import Page404 from './404.vue'
export default {
  components: {
    Page404
  },
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },
  layout: 'blog' // you can set a custom layout for the error page
}
</script>
